// Adapted from EventEndingRow.jsx
import React from "react";

import cx from "classnames";
import { isBefore, startOfDay } from "date-fns";
import { range } from "lodash";
import PropTypes from "prop-types";

import EventRowMixin from "./EventRowMixin";
import { eventLevels } from "./utils/eventLevels";

const isSegmentInSlot = (seg, slot) => seg.left <= slot && seg.right >= slot;
const eventsInSlot = (segments, slot) => segments.filter(seg => isSegmentInSlot(seg, slot));

class AllDayRowCollapsed extends React.Component {
	render() {
		let {
			segments,
			slotMetrics: { slots },
		} = this.props;
		let rowSegments = eventLevels(segments).levels[0];

		let current = 1,
			lastEnd = 1,
			row = [];

		while (current <= slots) {
			let key = `_lvl_${current}`;

			let { event, left } = rowSegments.filter(seg => isSegmentInSlot(seg, current))[0] || {}; //eslint-disable-line

			if (!event) {
				current++;
				continue;
			}

			let gap = Math.max(0, left - lastEnd);

			if (gap) {
				row.push(EventRowMixin.renderSpan(slots, gap, `${key}_gap`));
			}

			row.push(EventRowMixin.renderSpan(slots, 1, key, this.renderShowMore(segments, current)));
			lastEnd = current = current + 1;
		}

		return <div className="fbc-row">{row}</div>;
	}

	canRenderSlotEvent(slot, span) {
		let { segments } = this.props;

		return range(slot, slot + span).every(s => {
			let count = eventsInSlot(segments, s).length;

			return count === 1;
		});
	}

	renderShowMore(segments, slot) {
		const events = eventsInSlot(segments, slot);
		const count = events.length;
		const isPast = events.reduce((isPast, { event }) => isPast && isBefore(startOfDay(event.end), new Date()), true);

		return count ? (
			<button
				type="button"
				key={`sm_${slot}`}
				className={cx("fbc-allday-row-count-toggle", { "fbc-in-the-past": isPast })}
				onClick={e => this.showMore(slot, e)}
			>
				{count} all-day event{count > 1 && "s"}
			</button>
		) : (
			false
		);
	}

	showMore(slot, e) {
		e.preventDefault();
		e.stopPropagation();
		this.props.onShowMore(slot, e.target);
	}
}

AllDayRowCollapsed.propTypes = {
	segments: PropTypes.array,
	slots: PropTypes.number,
	onShowMore: PropTypes.func,
	...EventRowMixin.propTypes,
};

AllDayRowCollapsed.defaultProps = {
	...EventRowMixin.defaultProps,
};

export default AllDayRowCollapsed;
